export default __webpack_public_path__ + "static/media/bg-destaque.74019987.png";